<template>
  <div class="posi-fiexd" v-if="dataVal.flag">
    <div class="posi-center">
      <div class="posi-head">
        <div class="posi-title">{{ dataVal.title }}</div>
        <i @click="handleClose" class="el-icon-close"></i>
      </div>
      <div class="posi-over">
        <div class="posi-from">
          <div class="posi-item col3 mt0">
            <div class="posi-item-input">
              <el-input v-model="fromData.title" :placeholder="dataVal.place||'请输入类目名称'"></el-input>
            </div>
          </div>
        </div>
      </div>
      <div class="posi-btn">
        <div class="hui" @click="handleClose">{{ dataVal.btn2 || "取消" }}</div>
        <div @click="handleSubmit">{{ dataVal.btn1 || "确定" }}</div>
      </div>
    </div>
  </div>
</template>
  <script>
export default {
  name: "Popup",
  props: ["dataVal"],
  data() {
    return {
      fromData: {
        title: "",
        submitFlag: false,
      },
    };
  },
  mounted() {
  },
  methods: {
    //提交
    handleSubmit() {
      let obj = {
        title: this.fromData.title,
        submitFlag: true,
      };
      this.$emit("transferNannyCell", obj);
    },
    //关闭
    handleClose() {
      let obj = {
        submitFlag: false,
      };
      this.$emit("transferNannyCell", obj);
    },
  },
  watch: {
    dataVal: {
      handler(newVal, oldVal) {
        if(newVal.edit == 1){
          this.fromData.title = newVal.content;
        }else {
          this.fromData.title = "";
        }
      },
      deep: true,
    },
  },
};
</script>
<style>
.el-select-dropdown {
  z-index: 10000 !important;
}
</style>
  <style lang="scss" scoped>
.posi-fiexd {
  @include flex-center(center, center);
}

.posi-center {
  width: 618px;
  height: 274px;
  border-radius: 25px;
  background-color: #fff;
  overflow: hidden;
  .posi-head {
    height: 70px;
    padding: 0 36px 0 32px;
    background-color: #f2f6ff;
    @include flex-center(space-between, center);
    .posi-title {
      font-size: 20px;
      font-weight: 700;
      color: #202224;
    }
    i {
      font-size: 20px;
      color: #aeaeb2;
      cursor: pointer;
    }
  }
  .posi-over {
    font-size: 16px;
    color: #000000;
    padding-left: 79px;
    padding-right: 87px;
    padding-top: 30px;
    .posi-from {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;

      .posi-item {
        width: 360px;
        margin-right: 60px;
        margin-bottom: 60px;
        .posi-item-title {
          color: #606060;
          font-size: 14px;
          font-weight: 600;
          margin-bottom: 11px;
          @include flex-center(flex-start, center);
          &::after {
            content: "*";
            display: block;
            color: #ff3b30;
            font-size: $f-size-14;
          }
        }
        /deep/.posi-item-input {
          width: 100%;

          .el-select {
            width: 100%;
          }
          input {
            width: 100%;
            height: 52px;
            background-color: #f5f6fa;
            //   color: #a6a6a6;
            color: #000;
            font-size: 14px;
            border: 1px solid #f5f6fa;
            outline: none;
            padding-left: 16px;
          }
          /deep/.el-input__inner {
            height: 52px;
            line-height: 52px;
            background-color: #f5f6fa;
            color: #000;
            font-size: 14px;
            border: 1px solid #f5f6fa;
          }
        }
        .sex {
          width: 100%;
          margin: 25px 0 30px;
          @include flex-center(center, center);
          border-radius: 5px;
          .sex-item {
            @include flex-center(center, center);
            color: #000000;
            font-size: $f-size-14;
            cursor: pointer;
            .sex-yuan {
              width: 10px;
              height: 10px;
              border: 1px solid #aeaeb2;
              border-radius: 50%;
              margin-right: 6px;
            }
            .sex-active {
              background-color: $y-color;
              border: 1px solid $y-color;
            }
            &:first-child {
              margin-right: 91px;
            }
            &:hover {
              color: $y-color;
            }
          }
        }
      }
      .col3 {
        width: 100%;
        margin-right: 0;
      }
      .col1 {
        width: calc((100% - 50px) / 3);
        margin-right: 25px;
      }
      .col2 {
        width: calc(((100% - 25px) / 3 * 2));
      }
      .mr0 {
        margin-right: 0;
      }
      .mt0 {
        margin-bottom: 0;
      }
    }
  }
  .posi-btn {
    padding-top: 40px;
    @include flex-center(center, center);
    div {
      width: 100px;
      height: 35px;
      background-color: #007aff;
      border-radius: 4px;
      font-size: 12px;
      font-weight: 400;
      color: #fff;
      @include flex-center(center, center);

      cursor: pointer;
    }
    .hui {
      margin-right: 42px;
      background-color: #f5f5f5;
      color: #363636;
    }
  }
}
</style>